export default {
      id: "ic_feuilleter-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic_feuilleter-usage",
      toString: function () {
        return this.url;
      }
    }